import { useNavigate } from "react-router-dom";
import { Header } from "@/components/Header";
import { Button } from "@/components/ui/button";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-background">
      <Header />
      <div className="max-w-lg mx-auto px-5 py-24 text-center fade-up" data-testid="payment-cancel-page">
        <div className="flex justify-center mb-6"><XCircle className="w-14 h-14 text-rose-brand" /></div>
        <h1 className="font-serif text-3xl text-olive">Paiement annulé</h1>
        <p className="text-muted-foreground mt-2">Votre réservation n'a pas été finalisée. Vous pouvez réessayer à tout moment.</p>
        <Button onClick={() => navigate("/")} className="mt-8 bg-olive hover:bg-olive-dark text-white rounded-full px-8" data-testid="back-home-button">
          Retour à l'accueil
        </Button>
      </div>
    </div>
  );
}
